import { approveRequireApprovePoint, getRequireApprovePoint } from "services/pointApi";
import { useMutation, UseMutationResult, useQuery, UseQueryResult } from "@tanstack/react-query";
import { ApprovePointInput, ApprovePointResponse, GetRequireApprovePointInput, GetRequireApprovePointResponse } from "services/interface";



//factory/points/find_all
export const useRequireApprovePoint = (
  input: GetRequireApprovePointInput
): UseQueryResult<GetRequireApprovePointResponse, Error> => {
  return useQuery<GetRequireApprovePointResponse, Error>({
    queryKey: ['require_approve_point', input],
    queryFn: () => getRequireApprovePoint(input),
    staleTime: 1000 * 60 * 60 * 24,
  });
};

//factory/points/approve// Get Agent By Telephone (Mutation)
export const useApproveRequireApprovePoint = (): UseMutationResult<
  ApprovePointResponse,
  Error,
  ApprovePointInput,
  unknown
> => {
  return useMutation<ApprovePointResponse, Error, ApprovePointInput, unknown>({
    mutationFn: (input: ApprovePointInput) => approveRequireApprovePoint(input),
  })
}